module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer_container"
  }, [_vm._v("\n    font by "), _c('a', {
    attrs: {
      "href": "http://sozaiya405.chu.jp/405/",
      "title": "「素材屋405番地」",
      "target": "_blank"
    }
  }, [_vm._v("「素材屋405番地」 ")]), _vm._v(" "), _c('br'), _vm._v("\n    illust by "), _c('a', {
    attrs: {
      "href": "http://www.irasutoya.com/",
      "title": "いらすとや",
      "target": "_blank"
    }
  }, [_vm._v("いらすとや")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-fbd7d122!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppFooter.vue
// module id = 227
// module chunks = 1